import { Chip, type ChipProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export const SkillBadge = (props: ChipProps) => {
  const theme = useTheme();

  return (
    <Chip
      {...props}
      size="small"
      variant="outlined"
      sx={{
        ...props?.sx,
        borderColor: 'divider',
        color: theme.palette.text.secondary,
      }}
    ></Chip>
  );
};
